var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 81 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36B37E",
    d: "M40.501 7.167C22.057 7.167 7.168 22.055 7.168 40.5c0 18.444 14.889 33.333 33.333 33.333 18.445 0 33.334-14.889 33.334-33.333 0-18.445-14.89-33.333-33.334-33.333m14.336 21.002 4.662 4.662L33.835 58.5 21.504 46.164l4.661-4.662 7.67 7.663z"
  })));
};
export default SvgCheckMark;